import { createResource } from 'react-resource-router';

import {
	getGlobalPolicies,
	getNotificationPolicies,
	getPolicyMaintenanceRights,
	getTeamPolicies,
} from '../endpoints';

export const teamPolicyResource = createResource({
	type: 'teamPolicyResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return `team-policy/${teamId ?? ''}`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		// if there is no teamId, this means that we are on the global policy page.
		// so we can return null directly, instead of sending fetch request.
		if (!teamId) {
			return null;
		}

		return getTeamPolicies(teamId);
	},
	isBrowserOnly: true,
});

export const notificationPolicyResource = createResource({
	type: 'notificationPolicyResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return `notification-policy/${teamId}`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		if (!teamId) {
			return;
		}

		return getNotificationPolicies(teamId);
	},
	isBrowserOnly: true,
});

export const globalPolicyResource = createResource({
	type: 'globalPolicyResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		if (teamId) {
			return `global-policy/${teamId}`;
		}

		return 'global-policy';
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return getGlobalPolicies(teamId);
	},
	isBrowserOnly: true,
});

export const policyMaintenanceRightsResource = createResource({
	type: 'policyMaintenanceRightsResource',
	getKey: () => 'policy-maintenance-rights-resource',
	getData: async () => {
		return getPolicyMaintenanceRights();
	},
	isBrowserOnly: true,
});

export const resources = () => [
	teamPolicyResource,
	globalPolicyResource,
	policyMaintenanceRightsResource,
	notificationPolicyResource,
];
